import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import styled from 'styled-components';
import { RefreshCw } from 'lucide-react';

const LoadingContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.gray50};
`;

const LoadingSpinner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const SpinningIcon = styled(RefreshCw)`
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <LoadingContainer>
        <LoadingSpinner>
          <SpinningIcon size={48} />
          <span>Verificando autenticación...</span>
        </LoadingSpinner>
      </LoadingContainer>
    );
  }

  if (!isAuthenticated) {
    // Si no está autenticado, el componente padre (App) debe mostrar el login
    return null;
  }

  return <>{children}</>;
};

export default ProtectedRoute;